import Rails from "@rails/ujs"
import Global from "./global_functions"

class GroupScrollFunctions {

    eventId = -1;
    trainingsPlanArea

    constructor() {
        console.log('init Group Scroll... ');
        this.trainingsPlanArea = document.querySelector('#trainings_plan_container');
        const current_date_item = this.trainingsPlanArea.querySelector('.current_date');
        if (current_date_item != null)
            this.current_date.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
        else
            document.querySelector('.trainingsplan_item_group').querySelector('.header_col').scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
        // this.trainingsPlanArea.addEventListener('scroll', event => {
        //     event.preventDefault();
        //     console.log('scroll!!!');
        // })
    }

    // center_current_date() {
    //     const item_width = this.trainingsPlanArea.querySelector('.current_date').getBoundingClientRect().width;
    //     const item_left = this.trainingsPlanArea.querySelector('.current_date').getBoundingClientRect().left;
    //     const area_width = this.trainingsPlanArea.getBoundingClientRect().width;
    //     const scroll_left = (area_width - item_width) / 2;
    //     console.log(item_left);
    //     this.trainingsPlanArea.scrollTo({
    //         top: 0,
    //         left: 100,
    //         behavior: 'smooth'
    //     });
    //
    //
    // }

}
const groupScrollFunctions = new GroupScrollFunctions();